import { Icon } from '@material-ui/core';
import Fab from '@material-ui/core/Fab';
import * as React from 'react';
import { useTranslator } from '~frontend-common/i18n/translator';
import { Box } from '~ui-kit/components/box';
import { styled } from '~ui-kit/styled-components';
import { Img } from './img.component';
import { H1, H3 } from './typography.component';

interface Props {
  redirectionPath: string;
  imagesSrc: any;
}

export const NotFound: React.FunctionComponent<Props> = ({ imagesSrc, redirectionPath }) => {
  const { tl } = useTranslator();

  return (
    <Wrapper>
      <Box
        id="main-box"
        flexDirection={['column', 'column', 'column', 'row']}
        width={['320px', '450px', '450px', '1024px']}
        alignItems="center"
        justifyContent="start"
      >
        <Box id="box-logo" mt={[5]}>
          <Logo
            mr={[0, 0, 0, 7]}
            pt={[3, 3, 3, 0]}
            pb={[0, 3]}
            px={[3, 5]}
            width={['10em', '15em', '15em', '20em']}
            height={['250px', '300px', '300px', '100%']}
            src={imagesSrc.error.fourOfour}
          />
        </Box>
        <Box
          id="box-text"
          alignItems={['center', 'center', 'center', 'baseline']}
          justify={['center']}
          flexDirection="column"
        >
          <H1 fontSize={[10]} fontWeight={400} mb={[2]}>
            {tl('error.common.fourOfour.headline')}
          </H1>
          <H3 fontSize={[6]} mb={[2]} textAlign={['center', 'center', 'center', 'start']}>
            {tl('error.common.fourOfour.title')}
          </H3>
          <H3 color="secondary" fontSize={[4]} mb={[5]} textAlign={['center', 'center', 'center', 'start']}>
            {tl('error.common.fourOfour.subtitle')}
          </H3>
          <Fab variant="extended" color="primary" size="large" type="link" href={redirectionPath}>
            {tl('buttons.home')}
            <Icon>chevron_right</Icon>
          </Fab>
        </Box>
      </Box>
    </Wrapper>
  );
};

const Wrapper = styled(Box)`
  justify-content: center;
  height: 100%;
`;

const Logo = styled(Img)`
  flex-grow: 1;
  position: relative;
`;
